import { lenis } from '../global/gsap';

const initScrollTo = (elements) => {
    elements.forEach((element) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();

            let offset = 0;

            if (element.dataset.scrollOffset) {
                offset = Number(element.dataset.scrollOffset);
            }

            const target = `#${element.hash.substr(1)}`;

            lenis.scrollTo(target, { offset, duration: 0.75 });
        });
    });
};

export { initScrollTo as default };
